<div class="partial-invoice-section">
  <mat-card #panel>
    <mat-card-content>
      <div class="invoice-title">
        @if (document.date) {
          <div class="received-date">
            {{ document.date | dateepoch: timezone }} {{ document.date | time: timezone }}
          </div>
        }
        <div class="invoice-number">
          <h5><span class="subtitle-1">Invoice</span> {{ invoice.invoiceNumber }}</h5>
          @if (invoice.status === 'APPROVED') {
            <div
              (click)="$event.stopPropagation(); tooltipApprovedDate.toggle()"
              class="invoice"
              [appHighlightStatus]="invoice.status">
              APPROVED
              <div
                #tooltipApprovedDate="matTooltip"
                matTooltip="{{ invoice.acceptedOrRejectedDateTime | dateepoch: timezone }} {{
                  invoice.acceptedOrRejectedDateTime | time: timezone
                }}"
                matTooltipClass="timestamp-tooltip"></div>
            </div>
          }
          @if (invoice.status === 'ADJUSTED') {
            <div
              (click)="$event.stopPropagation(); tooltipAdjustedDate.toggle()"
              class="invoice"
              [appHighlightStatus]="invoice.status">
              ADJUSTED
              <div
                #tooltipAdjustedDate="matTooltip"
                matTooltip="{{ invoice.acceptedOrRejectedDateTime | dateepoch: timezone }} {{
                  invoice.acceptedOrRejectedDateTime | time: timezone
                }}"
                matTooltipClass="timestamp-tooltip"></div>
            </div>
          }
          @if (invoice.status === 'REJECTED') {
            <div
              (click)="$event.stopPropagation(); tooltipRejectedDate.toggle()"
              class="invoice"
              [appHighlightStatus]="invoice.status">
              REJECTED
              <div
                #tooltipRejectedDate="matTooltip"
                matTooltip="{{ invoice.acceptedOrRejectedDateTime | dateepoch: timezone }} {{
                  invoice.acceptedOrRejectedDateTime | time: timezone
                }}"
                matTooltipClass="timestamp-tooltip"></div>
            </div>
          }
          @if (invoice.status === 'PENDING_FOR_REVIEW') {
            <div
              (click)="$event.stopPropagation(); tooltipPendingDate.toggle()"
              class="invoice"
              [appHighlightStatus]="invoice.status">
              PENDING
              <div
                #tooltipPendingDate="matTooltip"
                matTooltip="{{ invoice.acceptedOrRejectedDateTime | dateepoch: timezone }} {{
                  invoice.acceptedOrRejectedDateTime | time: timezone
                }}"
                matTooltipClass="timestamp-tooltip"></div>
            </div>
          }
          <div class="invoice" appHighlightStatus="MIGRATED">MIGRATED</div>
        </div>
      </div>
      <div>
        @if (invoice.partialTotalInvoicedAmount) {
          <div class="labels body-2">Total Invoiced</div>
          <div class="data-values subtitle-2">$ {{ invoice.partialTotalInvoicedAmount | number: '1.2-2' }}</div>
        }
      </div>
      <div class="flex items-center justify-end secondary-icon">
        <pdf-button (openPDF)="openInvoiceReport()" />
      </div>
    </mat-card-content>
  </mat-card>
</div>
